/* @flow */

import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Button, Menu, Segment, Icon } from 'semantic-ui-react';
import { getViewComponent } from 'catalog/plugin';
import PageTemplateLabel
  from 'catalog/screens/shared/components/PageTemplateLabel';

type Props = {
  page: CatalogPage,
  content: CatalogPageContent,
  history: Object,
};

const styles = {
  container: {
    marginTop: '1rem',
  },
};

const CatalogPageItem = ({ page, content, history }: Props) => {
  const renderContent = () => {
    const templateContent = getViewComponent(page.template.code, content);
    if (templateContent) {
      return templateContent;
    }

    console.warn(
      `Cannot render content as template type ${page.template.code} is unknown.`
    );
    return null;
  };

  return (
    <div style={styles.container}>
      <Menu attached="top" borderless>
        {!page.isRoot &&
          <Menu.Item>
            <Button
              onClick={history.goBack}
              labelPosition="left"
              icon="chevron circle left"
              content="Revenir"
            />
          </Menu.Item>}
        <Menu.Item header>
          {page.name}
        </Menu.Item>
        <Menu.Item>
          <PageTemplateLabel page={page} />
        </Menu.Item>
        <Menu.Menu position="right">
          <Menu.Item>
            <Link
              to={`/pages/${page.id}`}
              target="innoctopus"
              className="ui labeled icon button"
            >
              <Icon name="edit" />
              Editer
            </Link>
          </Menu.Item>
        </Menu.Menu>
      </Menu>
      <Segment attached="bottom">
        {renderContent()}
      </Segment>
    </div>
  );
};

export default withRouter(CatalogPageItem);



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Catalog/components/CatalogPageItem.js